export const PALETTE_PRIMARY_DARK = '#024076';
export const PALETTE_NEUTRAL_LIGHT = '#DEDEDE';
export const PALETTE_NEUTRAL_DARK = '#747474';
export const PALETTE_ERROR_MAIN = '#CD3333';
export const PALETTE_WARNING_MAIN = '#F37012';
export const PALETTE_BLUE_1200 = '#03559D';
export const PALETTE_BLUE_400 = '#9BC3E7';
export const PALETTE_BLUE_100 = '#E5F0F9';
export const PALETTE_BLUE_50 = '#F2F7FC';
export const PALETTE_RED_1400 = '#7B1F1F';
export const PALETTE_GRAY_600 = '#BDBDBD';
export const PALETTE_MAGENTA_1200 = '#AC3C7A';
export const CUSTOM_WARNING = '#FFB74D';
export const CUSTOM_OK = '#8FC23A';
export const CUSTOM_BLUE = '#20427E';
export const WHITE = '#FFFFFF';
export const BLACK = '#AAAAAA';
export const TRANSPARENT = '#00FFFFFF';
export const SHADOW = '#00223F26';
export const DEMAND_COLOUR = '#4C277D';
export const DELIVERY_COLOUR = '#A8186E';
